import React from 'react'
import {Field} from "./index";
import {Col} from "antd";
import Utils from "../../utils";


export class FieldBlank extends Field {

  constructor(obj={}) {
    super(obj);
  }

  getComponent (form) {

    return () => {
      const visible = Utils.evaluateFormula(this.condition, form)

      return (
        <Col className={!visible ? "display-none" : "visible"} xs={24} sm={24}
             md={this.size}>
          <div></div>
        </Col>)
    };

  }

  transformToField = (data) => {
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.condition = data.condition ?? true;
    return this;
  }
}